
import { Link } from 'react-router-dom';

const NewsSection = () => {
  const news = [
    {
      id: 1,
      date: '2025.01.15',
      category: 'お知らせ',
      title: '年末年始の営業時間のご案内',
    },
    {
      id: 2,
      date: '2025.01.10',
      category: 'イベント',
      title: 'ペット供養祭を開催いたします',
    },
    {
      id: 3,
      date: '2024.12.20',
      category: 'お知らせ',
      title: '新しい納骨室が完成いたしました',
    },
    {
      id: 4,
      date: '2024.12.15',
      category: 'サービス',
      title: '小動物専用の火葬プランを開始しました',
    },
  ];

  return (
    <section className="py-16 sm:py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8 sm:mb-10">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800">
            お知らせ
          </h2>
        </div>

        <div className="space-y-4">
          {news.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow cursor-pointer group"
            >
              <div className="flex items-center gap-4">
                <div className="flex-shrink-0 bg-purple-100 text-purple-700 text-xs font-medium px-3 py-2 rounded-lg">
                  {item.date}
                </div>
                <div className="flex-shrink-0 bg-pink-100 text-pink-700 text-xs font-medium px-3 py-2 rounded-lg">
                  {item.category}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-base text-gray-800 truncate group-hover:text-purple-600 transition-colors">
                    {item.title}
                  </p>
                </div>
                <i className="ri-arrow-right-line text-purple-400 flex-shrink-0"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
